import { securityHighlights } from '../lib/marketing';

export function SecurityPage(): JSX.Element {
  return (
    <div className="space-y-12">
      <header className="space-y-4 text-center">
        <span className="badge-soft">Trust & privacy</span>
        <h1 className="text-4xl font-semibold text-foreground">Security woven into every inspection</h1>
        <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
          InspectAI safeguards imagery, resident details, and operational data with layered encryption, regional
          residency options, and enterprise-ready governance.
        </p>
      </header>

      <div className="grid gap-6 md:grid-cols-3">
        {securityHighlights.map((section) => (
          <div key={section.title} className="glass-card space-y-3 p-6">
            <h2 className="text-lg font-semibold text-foreground">{section.title}</h2>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {section.items.map((item) => (
                <li key={item}>• {item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <section className="glass-card space-y-3 p-6 text-sm text-muted-foreground">
        <h2 className="text-lg font-semibold text-foreground">Operational controls</h2>
        <ul className="grid gap-2 sm:grid-cols-2">
          <li>Role-based access: admin, agent, and view-only permissions</li>
          <li>Session management with automatic sign-out after inactivity</li>
          <li>Audit log of inspection edits, exports, and billing events</li>
          <li>Opt-in integrations with PropertyMe, Console Cloud, and Drive</li>
        </ul>
      </section>
    </div>
  );
}
